module.exports = __webpack_public_path__ + "img/grey.4eb6f6ae.png";